import { NgModule } from '@angular/core';
import { MatPopoverEditModule } from '@angular/material-experimental/popover-edit';

import { AdManagementRoutingModule } from './ad-management-routing.module';
import { AdManagementComponent } from './ad-management.component';
import { MerchantAdsComponent } from './merchant-ads/merchant-ads.component';
import { EditAdsDialogComponent } from './merchant-ads/edit-ads-dialog/edit-ads-dialog.component';
import {CreateAdDialogComponent} from './merchant-ads/create-ad-dialog/create-ad-dialog.component';
import { ScheduleAdsDialogComponent } from './merchant-ads/schedule-ads-dialog/schedule-ads-dialog.component';
import {PreviewAdDialogComponent} from './merchant-ads/preview-ad-dialog/preview-ad-dialog.component';
import {ActiveAffiliatesDialogComponent} from './merchant-ads/active-affiliates-dialog/active-affiliates-dialog.component';
import {ConversionRateDialogComponent} from './merchant-ads/conversion-rate-dialog/conversion-rate-dialog.component';
import { GetLinkDialogComponent } from './affiliate-ads/get-link-dialog/get-link-dialog.component';
import {ArchiveAdDialogComponent} from './merchant-ads/archive-ad-dialog/archive-ad-dialog.component';
import {SharedModule} from '../../shared/shared.module';
import {PipeModule} from '../../pipe/pipe.module';

@NgModule({
  declarations: [
    AdManagementComponent,
    MerchantAdsComponent,
    EditAdsDialogComponent,
    CreateAdDialogComponent,
    ScheduleAdsDialogComponent,
    PreviewAdDialogComponent,
    ActiveAffiliatesDialogComponent,
    ConversionRateDialogComponent,
    GetLinkDialogComponent,
    ArchiveAdDialogComponent
  ],
    imports: [
        MatPopoverEditModule,
        AdManagementRoutingModule,
        SharedModule,
        PipeModule
    ]
})
export class AdManagementModule { }
